export const validateMatchMaking = (question, index) => {
  try {
    const errors = [];

    if (question?.options?.length < 2) {
      errors.push({
        type: "display_name",
        questionIndex: index,
        message: `Instruction:${index + 1} At least 2 Questions are required in Matchmaking.`,
      });
    }

    // Check if instruction/question exists
    if (!question?.question || question?.question?.length === 0) {
      errors.push({
        type: "display_name",
        questionIndex: index,
        message: `Instruction:${index + 1} Instruction is required.`,
      });
    }

    // Validate each option in matchmaking
    if (question?.options?.length > 0) {
      question.options.forEach((option, optionIndex) => {

        if(question?.matchType === "ImageAndAudio"){
          if (!option?.match_audio || option?.match_audio?.trim().length === 0) {
            errors.push({
              type: "display_name",
              questionIndex: index,
              message: `Match Audio:${index + 1}.${optionIndex + 1}. is required.`,
            });
          }
        }
        if ((!option?.item || option?.item?.trim().length === 0) && (!option?.questionImage || option?.questionImage?.trim().length === 0) && (!option?.questionAudio || option?.questionAudio?.trim().length === 0)) {
          errors.push({
            type: "display_name",
            questionIndex: index,
            message: `Question:${index + 1}.${optionIndex + 1}. is required.`,
          });
        }
        if(question?.matchType === "Text"){
          if (!option?.match_text || option?.match_text?.trim().length === 0) {
            errors.push({
              type: "display_name",
              questionIndex: index,
              message: `Match answer text:${index + 1}.${optionIndex + 1}. is required.`,
            });
          }
        }else{
          if (!option?.match_item || option?.match_item?.trim().length === 0) {
            errors.push({
              type: "display_name",
              questionIndex: index,
              message: `Match Item:${index + 1}.${optionIndex + 1}. is required.`,
            });
          }
        }       
      });
    }

    return errors;
  } catch (error) {
    console.log(error);
  }
};

export const isQuestionEmpty = (questionValue) => {
  if (!questionValue) {
    return true;
  }
  if (typeof questionValue !== 'string') {
    return false;
  }
  const trimmedContent = questionValue.trim();
  if (trimmedContent.length === 0) {
    return true;
  }
  const emptyHtmlPatterns = [
    /^<p><br\s*\/?><\/p>$/i,
    /^<p><\/p>$/i,
    /^<p>\s*<\/p>$/i,
    /^<p>\s*<br\s*\/?>\s*<\/p>$/i,
    /^<div><br\s*\/?><\/div>$/i,
    /^<div><\/div>$/i,
    /^<div>\s*<\/div>$/i,
    /^<br\s*\/?>$/i,
    /^&nbsp;$/i,
    /^<p>&nbsp;<\/p>$/i,
    /^<p>\s*&nbsp;\s*<\/p>$/i,
    /^<p>\s*&nbsp;\s*<br\s*\/?>\s*<\/p>$/i,
    /^<p><br\s*\/?>\s*&nbsp;\s*<\/p>$/i,
  ];
  const matchesEmptyPattern = emptyHtmlPatterns.some((pattern) => pattern.test(trimmedContent));
  if (matchesEmptyPattern) {
    return true;
  }
  try {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = questionValue;
    const textContent = tempElement.textContent || tempElement.innerText || '';
    const cleanedText = textContent
      .replace(/\u00A0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return cleanedText.length === 0;
  } catch (error) {
    return false;
  }
};

export const assignmentDraftHasUserContent = ({ displayName, questions } = {}) => {
  const name = typeof displayName === 'string' ? displayName.trim() : '';
  if (name.length > 0) {
    return true;
  }
  const qs = Array.isArray(questions) ? questions : [];
  return qs.some((q) => !isQuestionEmpty(q?.question));
};
